import React, { useState, useRef, useEffect, } from 'react';
import { Input, Popup, Dropdown, Toast, InfiniteScroll, Modal } from 'antd-mobile'
import { DownOutline, UpOutline, FilterOutline, } from 'antd-mobile-icons'
import { cloneDeep } from 'lodash'
import { useThrottleFn } from 'ahooks'
import axios from 'axios';
import './index.less'
{/* <DownOutline /> */ }
{/* <UpOutline /> */ }

const SearchPage = () => {

  const tarRef = useRef()
  const dropRef = useRef()

  const [productData, setProductData] = useState([]);
  const [searchParams, setSearchParams] = useState(undefined);
  const [searchType, setSearchType] = useState(0);
  const [showTopPopup, setShowTopPopup] = useState(false);
  const [paramsClick1, setParamsClick1] = useState(0);
  const [paramsName1, setParamsName1] = useState('综合');
  const [paramsName2, setParamsName2] = useState([]);
  const [params2, setParams2] = useState([]);
  const [paramsName3, setParamsName3] = useState([]);
  const [params3, setParams3] = useState([])
  const [params4, setParams4] = useState([])
  const [params5, setParams5] = useState(undefined)
  const [params6, setParams6] = useState(undefined)
  const [bottomPopup, setBottomPopup] = useState(false);
  const [productList, setProductList] = useState([]);
  const [searchCondition, setSearchCondition] = useState({
    pageSize: 20,
    pageNumber: 1,
  })
  const [addressList, setAddressList] = useState([]);
  const [isMore, setIsMore] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dataNumber, setDataNumber] = useState(1);
  const [otherParams, setOtherParams] = useState({});

  // useEffect(() => {
  //   console.log('456')
  //   console.log(otherParams,'otherParams')
  //   if(JSON.stringify(otherParams) !== '{}'){
  //     console.log('789')
  //     getData(3, otherParams)
  //   }
  // }, [otherParams])

  const getOld = new Map([
    [1, '全新'],
    [2, '99新'],
    [3, '95新'],
    [4, '9成新'],
    [5, '8成新'],
    [6, '7成新'],
  ]);

  const cateItem2 = [
    { title: '全新', id: 1 },
    { title: '99新', id: 2 },
    { title: '95新', id: 3 },
    { title: '9成新', id: 4 },
    { title: '8成新', id: 5 },
    { title: '7成新', id: 6 },
  ]

  const cateItem1 = [
    { title: '7天无理由', id: 'isSevenDayReturn' },
    { title: '租满即送', id: 'minRentFull' },
    { title: '随租随还', id: 'isReturnAnyTime' },
    { title: '包邮', id: 'isPackageMail' },
    { title: '首月一元', id: 'firstRentOneCoupon' },
    { title: '首月五折', id: 'firstRentFiveCoupon' },
  ]

  const cateItem3 = [
    { title: '1天起租', id: 1 },
    { title: '3天起租', id: 3 },
    { title: '7天起租', id: 7 },
    { title: '30天起租', id: 30 },
    { title: '90天起租', id: 90 },
    { title: '180天起租', id: 180 },
    { title: '365天起租', id: 365 },
  ]

  const cateItem4 = [
    { title: '支持', id: 1 },
    { title: '不支持', id: 0 },
    { title: '', id: 2 },
  ]

  const submitForm = (data) => axios({
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'post',
    url: '/consumer-zhifubao/aliPay/index/aositem',
    responseType: 'json',
    data
  })

  const getData = (type, data) => {//type==1 搜索词搜索 type==2 滑动加载下一页 type==3 筛选参数
    console.log(data, 'data')
    let otherParamsObj = {}
    if (!searchParams && type !== 1) {
      Toast.show({
        content: '请输入搜索内容',
      })
      return
    }
    if (loading) {
      return
    }
    if (type == 3) {
      otherParamsObj = {
        ...otherParams,
        ...data
      }
      console.log(otherParamsObj, 'otherParamsObj')
    }
    setLoading(true)
    try {
      submitForm({
        ...searchCondition,
        pageNumber: type == 2 ? data : searchCondition.pageNumber,
        content: type == 1 ? data : searchParams,
        ...otherParamsObj,
      }).then(res => {
        if (type == 2) {
          let data = cloneDeep(productList)
          let newData = res?.data?.data?.records
          let dataList = data.concat(newData)
          setProductList(dataList)
          setDataNumber(res?.data?.data?.current)
          if (res?.data?.data?.total > dataList.length) {
            setIsMore(true)
          } else {
            setIsMore(false)
          }
        } else {
          if (res?.data?.data?.total > res?.data?.data?.records.length) {
            setIsMore(true)
          } else {
            setIsMore(false)
          }
          setDataNumber(res?.data?.data?.current)
          setProductList(res?.data?.data?.records)
        }
        // let data = cloneDeep(productList)
        // let newData = res?.data?.data?.records
        // let dataList = data.concat(newData)
        // setProductList(dataList)

        setAddressList(res?.data?.data?.cityCodes)
      })
    } finally {
      setLoading(false)
    }

  }

  const changeSearchType = (type) => {
    if (type == 4) {
      setBottomPopup(true)
      return
    }
    setSearchType(type)
    // setShowTopPopup(true)
  }

  const changeParamsClick1 = (type, name) => {
    setParamsClick1(type)
    setParamsName1(name)
  }

  const changeParamsClick2 = (names, ids) => {
    let oldPar = cloneDeep(paramsName2)
    let oldPar2 = cloneDeep(params2)
    if (oldPar.includes(names)) {
      oldPar = oldPar.filter(item => item !== names)
    } else {
      oldPar.push(names)
    }
    setParamsName2(oldPar)
    if (oldPar2.includes(ids)) {
      oldPar2 = oldPar2.filter(item => item !== ids)
    } else {
      oldPar2.push(ids)
    }
    setParams2(oldPar2)
  }

  const changeParamsClick3 = (names, codes) => {
    let oldPar = cloneDeep(params3)
    if (oldPar.includes(codes)) {
      oldPar = oldPar.filter(item => item !== codes)
    } else {
      oldPar.push(codes)
    }
    setParams3(oldPar)
    let oldPar1 = cloneDeep(paramsName3)
    if (oldPar1.includes(names)) {
      oldPar1 = oldPar1.filter(item => item !== names)
    } else {
      oldPar1.push(names)
    }
    setParamsName3(oldPar1)
  }

  const changeParamsClick4 = (codes) => {
    let oldPar = cloneDeep(params4)
    if (oldPar.includes(codes)) {
      oldPar = oldPar.filter(item => item !== codes)
    } else {
      oldPar.push(codes)
    }
    setParams4(oldPar)
  }

  const { run: loadMore } = useThrottleFn(
    async () => {
      let oldPar = cloneDeep(dataNumber)
      const append = await getData(2, oldPar + 1)

    },
    { wait: 1000, leading: true, trailing: false }
  )

  const clickSearch = (names) => {
    setSearchParams(names)
    getData(1, names)
  }

  const resetFun = (type) => {
    if (type == 1) {
      setParamsClick1(0)
      setParamsName1('综合')
    } else if (type == 2) {
      setParamsName2([])
      setParams2([])
    } else if (type == 3) {
      setParamsName3([])
      setParams3([])
    } else if (type == 4) {
      setParams4([])
      setParams5(undefined)
      setParams6(undefined)
    }
  }

  const confirmFun = (type) => {
    // console.log(dropRef,' dropRef.close()')
    // return
    let oldParams = cloneDeep(otherParams)
    let oldNewPar = cloneDeep(params2)
    let oldNewPar1 = cloneDeep(params3)
    let oldNewPar4 = cloneDeep(params4)
    let oldNewPar5 = cloneDeep(params5)
    let oldNewPar6 = cloneDeep(params6)
    let params = { ...oldParams }
    console.log(type, paramsName1, 'panduan1')
    if (type == 1) {
      if (paramsClick1 == 0 || paramsClick1 == 4) {
        params.saleSort = null
        params.orderBy = null
      } else if (paramsClick1 == 1) {
        params.saleSort = null
        params.orderBy = 'asc'
      } else if (paramsClick1 == 2) {
        params.saleSort = null
        params.orderBy = 'desc'
      } else if (paramsClick1 == 3) {
        params.saleSort = 1
        params.orderBy = null
      }
      console.log('123', params)
      setOtherParams((prev) => ({
        ...prev,
        ...params
      }))
      getData(3, params)
    } else if (type == 2) {
      params.oldNewDegreeStatusList = oldNewPar
      setOtherParams((prev) => ({
        ...prev,
        ...params
      }))
      getData(3, params)
    } else if (type == 3) {
      params.searCityCodeList = oldNewPar1
      setOtherParams((prev) => ({
        ...prev,
        ...params
      }))
      getData(3, params)
    } else if (type == 4) {
      params.isSiteSelf = oldNewPar6
      params.minRentCycleDays = oldNewPar5
      if (oldNewPar4.includes('isSevenDayReturn')) {
        params.isSevenDayReturn = 1
      } else {
        params.isSevenDayReturn = undefined
      }
      if (oldNewPar4.includes('minRentFull')) {
        params.minRentFull = 1
      } else {
        params.minRentFull = undefined
      }
      if (oldNewPar4.includes('isReturnAnyTime')) {
        params.isReturnAnyTime = 1
      } else {
        params.isReturnAnyTime = undefined
      }
      if (oldNewPar4.includes('isPackageMail')) {
        params.isPackageMail = 1
      } else {
        params.isPackageMail = undefined
      }
      if (oldNewPar4.includes('firstRentOneCoupon')) {
        params.firstRentOneCoupon = 1
      } else {
        params.firstRentOneCoupon = undefined
      }
      if (oldNewPar4.includes('firstRentFiveCoupon')) {
        params.firstRentFiveCoupon = 1
      } else {
        params.firstRentFiveCoupon = undefined
      }
      setOtherParams((prev) => ({
        ...prev,
        ...params
      }))
      getData(3, params)
    }
    setBottomPopup(false)
    dropRef.current.close()
  }

  const showModalFun = ( ids) => {
    Modal.show({
      content: (
        <div className='modalContentLinkContent' style={{ textAlign: 'center', background: '#fff' }} >
          <div className='modalContentLink_title' style={{
            fontFamily: 'PingFangSC, PingFang SC',
            fontWeight: 500,
            fontSize: '2.25rem',
            color: '#333',
            lineHeight: '2.5rem',
            fontStyle: 'normal',
          }} >
            请选择租赁方式
          </div>
          <div className='modalContentLink_box' style={{ display: 'flex', justifyContent: 'space-around', marginTop: '3rem' }} >
            <div className='modalContentLink_box_left' style={{
              width: '13.63rem',
              height: '4.5rem',
              borderRadius: '1rem',
              border: '0.06rem solid #cccccc',
              fontFamily: 'PingFangSC, PingFang SC',
              fontWeight: 400,
              fontSize: '1.75rem',
              color: '#333',
              lineHeight: '2.25rem',
              textAlign: 'center',
              lineHeight: '4.5rem',
              fontStyle: 'normal',
            }} onClick={() => toAlipay(1, ids)}  >个人租赁</div>
            <div className='modalContentLink_box_right' style={{
              width: '13.63rem',
              height: '4.5rem',
              borderRadius: '1rem',
              background: '#ED0000',
              fontFamily: 'PingFangSC, PingFang SC',
              fontWeight: 400,
              fontSize: '1.75rem',
              color: '#fff',
              lineHeight: '2.25rem',
              textAlign: 'center',
              lineHeight: '4.5rem',
              fontStyle: 'normal',
            }} onClick={() => toAlipay(2, ids)}>企业租赁</div>
          </div>
        </div>
      ),
      closeOnMaskClick: true,
      className: 'modalContentLink',
      bodyStyle: {
        background: '#fff'
      },
      disableBodyScroll: true
    })
  }

  const toAlipay = (type,  ids) => {
    // console.log(type,ids,'三个参数')
    // return
    if (type == 1) {
      window.location.href = `alipays://platformapi/startapp?appId=${2019011162880259}&page=pages/productDetail/index&query=${encodeURIComponent(`itemId=${ids}`)}`
    } else {
      window.location.href = `alipays://platformapi/startapp?appId=${2021004161622584}&page=pages/productDetail/index&query=${encodeURIComponent(`itemId=${ids}`)}`
    }
  }

  return (
    <div className='SearchPage' >
      <div className='SearchPage_header' >
        <div className='SearchPage_header_input' >
          <div className='input_icon' >

          </div>
          <Input type="text" placeholder="惠租 租享新生活" className="input_text" value={searchParams} onChange={(e) => setSearchParams(e)} />
        </div>
        <div className='SearchPage_header_btn' onClick={() => getData()} >
          搜索
        </div>
      </div>
      {!searchParams ? (
        <div className='SearchPage_recommen' >
          <div className='SearchPage_recommen_title' >
            热门搜索
          </div>
          <div className='SearchPage_recommen_box' >
            <div className='recommenItem' onClick={() => clickSearch('笔记本')} >
              笔记本
            </div>
            <div className='recommenItem' onClick={() => clickSearch('显示器')} >
              显示器
            </div>
            <div className='recommenItem' onClick={() => clickSearch('台式电脑')} >
              台式电脑
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div className='SearchPage_searchNav' >
            <div className='SearchPage_searchNav_left' >
              <Dropdown arrow={<DownOutline />} ref={dropRef} >
                <Dropdown.Item key='sorter' title={paramsName1}  >
                  <div className='leftItem_con' >
                    <div className={paramsClick1 == 0 ? 'leftItem_con_click' : 'leftItem_con_normal'} onClick={() => changeParamsClick1(0, '综合')} >
                      综合
                    </div>
                    <div className={paramsClick1 == 1 ? 'leftItem_con_click' : 'leftItem_con_normal'} onClick={() => changeParamsClick1(1, '价格升序')} >
                      价格升序
                    </div>
                    <div className={paramsClick1 == 2 ? 'leftItem_con_click' : 'leftItem_con_normal'} onClick={() => changeParamsClick1(2, '价格降序')} >
                      价格降序
                    </div>
                    <div className={paramsClick1 == 3 ? 'leftItem_con_click' : 'leftItem_con_normal'} onClick={() => changeParamsClick1(3, '销量降序')} >
                      销量降序
                    </div>
                    <div className={paramsClick1 == 4 ? 'leftItem_con_click' : 'leftItem_con_normal'} onClick={() => changeParamsClick1(4, '销量升序')} >
                      销量升序
                    </div>
                    <div className='leftItem_con_btnBox' >
                      <div className='leftItem_con_btnBox_left' onClick={() => resetFun(1)} >
                        重置
                      </div>
                      <div className='leftItem_con_btnBox_right' onClick={() => confirmFun(1)} >
                        确定
                      </div>
                    </div>
                  </div>
                </Dropdown.Item>
                <Dropdown.Item
                  key='bizop'
                  title={paramsName2.length < 1 ? '成新度' : paramsName2.join('/')}
                  arrow={<DownOutline />}
                >
                  <div className='leftItem_con1'>
                    {cateItem2.map(item => (
                      <div onClick={() => changeParamsClick2(item.title, item.id)} className={paramsName2.includes(item.title) ? 'leftItem_con1_click' : 'leftItem_con1_normal'} >
                        {item.title}
                      </div>
                    ))}
                    <div className='leftItem_con_btnBox' >
                      <div className='leftItem_con_btnBox_left' onClick={() => resetFun(2)}  >
                        重置
                      </div>
                      <div className='leftItem_con_btnBox_right' onClick={() => confirmFun(2)} >
                        确定
                      </div>
                    </div>
                  </div>
                </Dropdown.Item>
                <Dropdown.Item key='more' title='发货地'>
                  <div className='leftItem_con2' >
                    <div className='leftItem_con2_title' >
                      发货地
                    </div>
                    <div className='leftItem_con2_ItemBox' >
                      {addressList && addressList.length > 0 && addressList.map(item => (
                        <div className={params3.includes(item.cityCode) ? 'leftItem_con2_ItemClick' : 'leftItem_con2_Item'} onClick={() => changeParamsClick3(item.cityName, item.cityCode)} >
                          {item.cityName}
                        </div>
                      ))}
                    </div>
                    <div className='leftItem_con_btnBox' >
                      <div className='leftItem_con_btnBox_left' onClick={() => resetFun(3)}  >
                        重置
                      </div>
                      <div className='leftItem_con_btnBox_right' onClick={() => confirmFun(3)} >
                        确定
                      </div>
                    </div>
                  </div>
                </Dropdown.Item>
              </Dropdown>
              {/* <div className='left_item' onClick={() => changeSearchType(1)} >
                <div className={searchType === 1 ? 'left_item_titleColor' : 'left_item_title'} >
                  综合
                </div>
                {searchType === 1 ? (
                  <UpOutline color='#F52C1D' className='left_item_icon' />
                ) : (
                  <DownOutline className='left_item_icon' />
                )}

              </div>
              <div className='left_item' onClick={() => changeSearchType(2)} >
                <div className={searchType === 2 ? 'left_item_titleColor' : 'left_item_title'} >
                  成新度
                </div>
                {searchType === 2 ? (
                  <UpOutline color='#F52C1D' className='left_item_icon' />
                ) : (
                  <DownOutline className='left_item_icon' />
                )}
              </div>
              <div className='left_item' onClick={() => changeSearchType(3)} >
                <div className={searchType === 3 ? 'left_item_titleColor' : 'left_item_title'} >
                  发货地
                </div>
                {searchType === 3 ? (
                  <UpOutline color='#F52C1D' className='left_item_icon' />
                ) : (
                  <DownOutline className='left_item_icon' />
                )}
              </div> */}
            </div>
            <div className='SearchPage_searchNav_right' onClick={() => changeSearchType(4)} >
              <div className='right_title' >
                筛选
              </div>
              <FilterOutline className='right_icon' />
            </div>
          </div>
          {productList.length < 1 ? (
            <div className='SearchPage_emptyPage' ref={tarRef} id='Popup' >
              {/* {console.log(tarRef.current, 'tarRef', tarRef)} */}

            </div>
          ) : (
            <div className='SearchPage_productBox' >
              {productList.map(item => (
                <div className='SearchPage_productBox_item' onClick={() => showModalFun(item.itemId)} >
                  <div className='productItem_pic' style={{ backgroundImage: `url(${item?.image})` }} >

                  </div>
                  <div className='productItem_titleBox' >
                    <div className='productItem_titleBox_old' >
                      {getOld.get(Number(item?.oldNewDegree))}
                    </div>
                    <div className='productItem_titleBox_title' >
                      {item?.name || '-'}
                    </div>
                  </div>
                  <div className='productItem_tagBox' >
                    {item?.productServiceLabels && item?.productServiceLabels.length > 0 && (
                      item?.productServiceLabels.map(_item => (
                        <div className='productItem_tagBox_item' >
                          {_item?.serviceLabName}
                        </div>
                      ))
                    )}
                  </div>
                  <div className='productItem_bottom' >
                    <div className='productItem_bottom_price' >
                      <span>¥</span>
                      <span className='productItem_bottom_price_big' >{item?.minDailyRent}</span>
                      <span>/天</span>
                    </div>
                    {item.unionProductStatus && (
                       <div className='productItem_bottom_flag' ></div>
                    )}
                   
                  </div>
                </div>
              ))}
              <InfiniteScroll loadMore={loadMore} hasMore={isMore} threshold={100} />
            </div>
          )
          }
        </div>
      )}
      <Popup
        visible={bottomPopup}
        onMaskClick={() => {
          setBottomPopup(false)
        }}
        onClose={() => {
          setBottomPopup(false)
        }}
        bodyStyle={{ height: '60vh' }}
      >
        <div className='Popup_title' >
          全部筛选
        </div>
        <div className='allPar' >
          <div className='Popup_secTitle' >
            发货与服务
          </div>
          <div className='Popup_parBox' >
            {cateItem1.map(item => (
              <div className={params4.includes(item.id) ? 'Popup_parItemClick' : 'Popup_parItem'} onClick={() => changeParamsClick4(item.id)} >
                {item.title}
              </div>
            ))}
          </div>
          {/* <div className='Popup_secTitle' >
            新旧程度
          </div>
          <div className='Popup_parBox' >
            {cateItem2.map(item => (
              <div className='Popup_parItem' >
                {item.title}
              </div>
            ))}
          </div> */}
          <div className='Popup_secTitle' >
            起租日
          </div>
          <div className='Popup_parBox' >
            {cateItem3.map(item => (
              <div className={params5 == item.id ? 'Popup_parItemClick' : 'Popup_parItem'} onClick={() => setParams5(item.id)} >
                {item.title}
              </div>
            ))}
          </div>
          <div className='Popup_secTitle' >
            支持自提
          </div>
          <div className='Popup_parBox' >
            {cateItem4.map(item => (
              <div className={params6 == item.id ? 'Popup_parItemClick' : 'Popup_parItem'} onClick={() => setParams6(item.id)} style={item.id == 2 ? { visibility: 'hidden' } : {}} >
                {item.title}
              </div>
            ))}
          </div>
        </div>
        <div className='Popup_btnBox' >
          <div className='Popup_btnBox_left' onClick={() => resetFun(4)} >
            重置
          </div>
          <div className='Popup_btnBox_right' onClick={() => confirmFun(4)} >
            确定
          </div>
        </div>
      </Popup>
    </div >
  )
}

export default SearchPage;